import { useEffect, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Swal from "sweetalert2";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayoutMin from "examples/LayoutContainers/DashboardLayoutMin";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import DynamicDialog from "components/MDDialog";
import LogoDialog from "components/MDLogoDialog";
import { hasPermissionDirect } from "../../../utils/hasPermissions";
import ActiveStatusCell from "../../../utils/ActiveStatusCell";
import fetchTableData from "../../../utils/fetchTableData";
import RowSocietyActionsMenu from "./RowSocietyActionsMenu";
import RowCollegeActionsMenu from "./RowCollegeActionsMenu";
import RowProgramActionsMenu from "./RowProgramActionsMenu";
import RowBranchActionsMenu from "./RowBranchActionsMenu";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
function SocietyClient() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const isActiveValue = (value) => value === "ACTIVE" || value === true || Number(value) === 1;
  const nextActiveValue = (value) => (isActiveValue(value) ? 0 : 1);
  const buildSocietyPayload = (source, currentUser, statusValue = source.is_society_active) => ({
    client_id: Number(currentUser.client_id),
    society_name: source.society_name || "",
    society_code: source.society_code || "",
    society_email: source.society_email || "",
    is_society_active: Number(statusValue),
    delete_status: Number(source.delete_status ?? 0),
    modified_by: currentUser?.user_email || "unknown",
  });
  const buildCollegePayload = (source, currentUser, statusValue = source.is_college_active) => ({
    client_id: Number(currentUser.client_id),
    society_id: Number(source.society_id || societyId),
    college_name: source.college_name || "",
    college_code: source.college_code || "",
    college_refurl: source.college_refurl || "",
    college_email: source.college_email || "",
    college_validity: source.college_validity ? Number(source.college_validity) : null,
    college_logopath: source.college_logopath || source.college_logourl || null,
    is_college_active: Number(statusValue),
    delete_status: Number(source.delete_status ?? 0),
    modified_by: currentUser?.user_email || "unknown",
  });
  const SocietyStatusCell = ({ value, row }) => (
    <ActiveStatusCell value={value} onClick={() => handleSocietyStatusToggle(row.original)} />
  );
  SocietyStatusCell.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
    row: PropTypes.shape({
      original: PropTypes.object.isRequired,
    }).isRequired,
  };
  const CollegeStatusCell = ({ value, row }) => (
    <ActiveStatusCell value={value} onClick={() => handleCollegeStatusToggle(row.original)} />
  );
  CollegeStatusCell.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
    row: PropTypes.shape({
      original: PropTypes.object.isRequired,
    }).isRequired,
  };
  const UserStatusCell = ({ value }) => <ActiveStatusCell value={value} />;
  UserStatusCell.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
  };
  const SocietyUserActionsCell = ({ row }) => (
    <Button color="error" onClick={() => handleSocietyUserDelete(row.original.user_id)}>
      Delete
    </Button>
  );
  SocietyUserActionsCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        user_id: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const CollegeUserActionsCell = ({ row }) => (
    <Button color="error" onClick={() => handleCollegeUserDelete(row.original.user_id)}>
      Delete
    </Button>
  );
  CollegeUserActionsCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        user_id: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };
  const [user, setUser] = useState(null);
  const [logoDialogOpen, setLogoDialogOpen] = useState(false);
  const [existUrl, setExistsUrl] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [scolumns, setSColumns] = useState([]);
  const [srows, setSRows] = useState([]);
  const [sopen, setSOpen] = useState(false);
  const [seditingId, setSEditingId] = useState(null);
  const [societyFormErrors, setSocietyFormErrors] = useState({});
  const [societyFormData, setSocietyFormData] = useState({
    society_id: "",
    society_name: "",
    society_email: "",
    society_code: "",
    is_society_active: "",
    client_id: "",
  });
  const [sucolumns, setSUColumns] = useState([]);
  const [surows, setSURows] = useState([]);
  const [suopen, setSUOpen] = useState(false);
  const [suview, setSUView] = useState(false);
  const [sueditingId, setSUEditingId] = useState(null);
  const [societyUserFormErrors, setSocietyUserFormErrors] = useState({});
  const [societyUserFormData, setSocietyUserFormData] = useState({
    society_id: "",
    society_name: "",
    is_user_active: "",
    user_email: "",
    user_email: "",
  });
  const [cucolumns, setCUColumns] = useState([]);
  const [curows, setCURows] = useState([]);
  const [cuopen, setCUOpen] = useState(false);
  const [cuview, setCUView] = useState(false);
  const [cueditingId, setCUEditingId] = useState(null);
  const [collegeUserFormErrors, setCollegeUserFormErrors] = useState({});
  const [collegeUserFormData, setCollegeUserFormData] = useState({
    college_id: "",
    college_name: "",
    is_user_active: "",
    user_email: "",
    user_email: "",
  });
  const [ccolumns, setCColumns] = useState([]);
  const [crows, setCRows] = useState([]);
  const [copen, setCOpen] = useState(false);
  const [openCollegesData, setOpenCollegesView] = useState(false);
  const [ceditingId, setCEditingId] = useState(null);
  const [societyId, setSocietyId] = useState(null);
  const [societyName, setSocietyName] = useState(null);
  const [collegeId, setCollegeId] = useState(null);
  const [collegeName, setCollegeName] = useState(null);
  const [programId, setProgramId] = useState(null);
  const [programName, setProgramName] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [branchName, setBranchName] = useState(null);
  const [collegeFormErrors, setCollegeFormErrors] = useState({});
  const [collegeFormData, setCollegeFormData] = useState({
    society_id: "",
    college_name: "",
    is_college_active: "",
    college_code: "",
    college_refurl: "",
    college_email: "",
    college_validity: "",
    db_instance_id: "",
    college_logourl: "",
  });
  const [cpcolumns, setCPColumns] = useState([]);
  const [cprows, setCPRows] = useState([]);
  const [cpopen, setCPOpen] = useState(false);
  const [cpview, setCPView] = useState(false);
  const [cpeditingId, setCPEditingId] = useState(null);
  const [collegeProgramFormErrors, setCollegeProgramFormErrors] = useState({});
  const [collegeProgramFormData, setCollegeProgramFormData] = useState({
    college_id: "",
    college_name: "",
    is_program_active: "",
    program_name: "",
    program_desc: "",
    program_duration: "",
    program_start_year: "",
  });
  const [pbcolumns, setPBColumns] = useState([]);
  const [pbrows, setPBRows] = useState([]);
  const [pbopen, setPBOpen] = useState(false);
  const [pbview, setPBView] = useState(false);
  const [pbeditingId, setPBEditingId] = useState(null);
  const [programBranchFormErrors, setProgramBranchFormErrors] = useState({});
  const [programBranchFormData, setProgramBranchFormData] = useState({
    program_id: "",
    college_id: "",
    branch_name: "",
    is_branch_active: "",
    branch_start_year: "",
    branch_desc: "",
  });
  const [abcolumns, setABColumns] = useState([]);
  const [abrows, setABRows] = useState([]);
  const [abopen, setABOpen] = useState(false);
  const [abview, setABView] = useState(false);
  const [abeditingId, setABEditingId] = useState(null);
  const [admissionBatchFormErrors, setAdmissionBatchFormErrors] = useState({});
  const [admissionBatchId, setAdmissionBatchId] = useState(null);
  const [admissionBatchName, setAdmissionBatchName] = useState(null);
  const [admissionBatchFormData, setAdmissionBatchFormData] = useState({
    college_id: "",
    admissionbatch_year: "",
    is_active: "",
    delete_status: "",
  });
  const [biopen, setBIOpen] = useState(false);
  const [biview, setBIView] = useState(false);
  const [bicolumns, setBIColumns] = useState([]);
  const [birows, setBIRows] = useState([]);
  const [branchIntakeFormErrors, setBranchIntakeFormErrors] = useState({});
  const [branchIntakeFormData, setBranchIntakeFormData] = useState({
    admittedbatch_id: "",
    intake: "",
  });
  const [admissionBatchOptions, setAdmissionBatchOptions] = useState([]);
  useEffect(() => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchSocieties();
    }
  }, [user]);

  const fetchSocieties = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/societies/${user.client_id}`, {
        headers: getAuthHeaders(),
      });

      setSColumns([
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
          accessor: "sno",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Society Name</span>,
          accessor: "society_name",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Active</span>,
          accessor: "is_society_active",
          Cell: SocietyStatusCell,
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Society Email</span>,
          accessor: "society_email",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Society Code</span>,
          accessor: "society_code",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
          accessor: "actions",
          align: "center",
          disableSortBy: true,
        },
      ]);

      const formattedRows = res.data.map((row, index) => ({
        sno: index + 1,
        ...row,
        client_id: Number(row.client_id || user.client_id),
        db_instance_id: Number(row.db_instance_id || user.db_instance_id),
        actions: (
          <RowSocietyActionsMenu
            row={{
              ...row,
              client_id: Number(row.client_id || user.client_id),
              db_instance_id: Number(row.db_instance_id || user.db_instance_id),
            }}
            onEdit={handleSocietyEdit}
            onSocietyDelete={handleSocietyDelete}
            onCreateSocietyUser={openSocietyUserDialog}
            onCreateCollege={openCollegeDialog}
            onViewSocietyUsers={openSocietyUsersView}
            onViewColleges={openCollegesView}
            hasPermissionDirect={hasPermissionDirect}
          />
        ),
      }));
      setSRows(formattedRows);
    } catch (error) {
      console.error("Error fetching societies:", error);
      showSnackbar("Failed to fetch societies", "error");
    }
  };

  const handleSocietyEdit = (row) => {
    setSocietyFormData({ ...row });
    setSEditingId(row.society_id);
    setSOpen(true);
  };
  const handleSocietyStatusToggle = async (row) => {
    const currentUser = JSON.parse(sessionStorage.getItem("user"));
    const nextStatus = nextActiveValue(row.is_society_active);

    try {
      await axios.put(
        `${API_BASE_URL}/api/societies/${currentUser.client_id}/${row.society_id}`,
        buildSocietyPayload(row, currentUser, nextStatus),
        {
          headers: getAuthHeaders(),
        }
      );
      showSnackbar(
        `Society status updated to ${nextStatus === 1 ? "Active" : "Inactive"}`,
        "success"
      );
      fetchSocieties();
    } catch (error) {
      console.error("Error updating society status:", error);
      showSnackbar("Error updating society status", "error");
    }
  };
  const handleFeeCategoryDelete = async (feecategory_id) => {
    let res;
    res = await axios.post(
      `${API_BASE_URL}/bootstrap-feetype.php?action=list&feecategory_id=${feecategory_id}&db_instance_id=${user.db_instance_id}`,
      null,
      {
        headers: getAuthHeaders(),
      }
    );
    if (Array.isArray(res.data)) {
      const confirm = await Swal.fire({
        title: "Fee types Already Exists for this FeeCategory?",
        icon: "warning",
        confirmButtonText: "Close!",
        willOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) {
            container.style.zIndex = "20000";
          }
        },
      });
    } else if (res.data.success === false) {
      const confirm1 = await Swal.fire({
        title: "Sure to delete FeeCategory?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        willOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) {
            container.style.zIndex = "20000";
          }
        },
      });

      if (confirm1.isConfirmed) {
        let response;
        try {
          response = await axios.post(
            `${API_BASE_URL}/bootstrap-feecategory.php?action=delete&feecategory_id=${feecategory_id}&db_instance_id=${user.db_instance_id}`,
            null,
            {
              headers: getAuthHeaders(),
            }
          );
          if (response.status === 200) {
            showSnackbar(" Fee Category Deleted successfully", "success");
          } else {
            showSnackbar(" Fee Category is not Deleted ", "error");
          }
          fetchFeeCategories();
        } catch (err) {
          showSnackbar("Error deleting Fee Category", "error");
        }
      }
    }
  };
  const handleSocietySave = async () => {
    const errors = {};
    if (!societyFormData.society_name?.trim()) {
      errors.society_name = "Society name is required";
    }
    if (!societyFormData.society_code?.trim()) {
      errors.society_code = "Society Code is required";
    }
    if (!societyFormData.society_email?.trim()) {
      errors.society_email = "Society email is required";
    }
    if (societyFormData.is_society_active === "") {
      errors.is_society_active = "Select status";
    }

    setSocietyFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    const user = JSON.parse(sessionStorage.getItem("user"));
    try {
      let response;
      if (seditingId) {
        response = await axios.put(
          `${API_BASE_URL}/api/societies/${user.client_id}/${seditingId}`,
          buildSocietyPayload(societyFormData, user),
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/api/societies`,
          {
            ...buildSocietyPayload(societyFormData, user),
            created_by: user?.user_email || "unknown",
          },
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        showSnackbar(message, "success");
      } else {
        showSnackbar("Something went wrong. Please try again.", "error");
      }
      setSOpen(false);
      fetchSocieties();
    } catch (error) {
      console.error("Error saving:", error);
      showSnackbar("Error saving data", "error");
    }
  };
  const openSocietyUserDialog = (society_id, society_name, db_instance_id) => {
    setSocietyUserFormData({
      society_id,
      society_name,
      db_instance_id,
      user_email: "",
      user_name: "",
      user_role_id: "2",
      is_user_active: "1",
      user_password: "",
    });
    setSUOpen(true);
    setSUEditingId(null);
    setSocietyId(society_id);
    setSocietyName(society_name);
    setSocietyUserFormErrors({});
  };
  const openSocietyDialog = () => {
    setSocietyFormData({
      society_id: "",
      society_name: "",
      society_code: "",
      society_email: "",
      is_society_active: "1",
      client_id: user?.client_id || "",
    });
    setSEditingId(null);
    setSOpen(true);
    setSocietyFormErrors({});
  };
  const handleSocietyDelete = async (society_id) => {
    const confirm = await Swal.fire({
      title: "Sure to delete Society?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });
    if (!confirm.isConfirmed) return;
    try {
      const currentUser = JSON.parse(sessionStorage.getItem("user"));
      await axios.delete(`${API_BASE_URL}/api/societies/${currentUser.client_id}/${society_id}`, {
        headers: getAuthHeaders(),
      });
      showSnackbar("Society deleted successfully", "success");
      fetchSocieties();
    } catch (error) {
      console.error("Error deleting society:", error);
      showSnackbar("Error deleting society", "error");
    }
  };
  const handleCollegeDelete = async (college_id, currentSocietyId) => {
    const confirm = await Swal.fire({
      title: "Sure to delete College?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });
    if (!confirm.isConfirmed) return;
    try {
      const currentUser = JSON.parse(sessionStorage.getItem("user"));
      await axios.delete(
        `${API_BASE_URL}/api/colleges/${currentUser.client_id}/${currentSocietyId}/${college_id}`,
        {
          headers: getAuthHeaders(),
        }
      );
      showSnackbar("College deleted successfully", "success");
      openCollegesView(currentSocietyId, societyName);
    } catch (error) {
      console.error("Error deleting college:", error);
      showSnackbar("Error deleting college", "error");
    }
  };
  const openSocietyUsersView = async (society_id, society_name) => {
    setSocietyId(society_id);
    setSocietyName(society_name);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/auth/users-by-client/${user.client_id}`, {
        headers: getAuthHeaders(),
      });
      setSUColumns([
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
          accessor: "sno",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>User Name</span>,
          accessor: "user_name",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>User Email</span>,
          accessor: "user_email",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Active</span>,
          accessor: "is_user_active",
          Cell: UserStatusCell,
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
          accessor: "actions",
          align: "center",
          disableSortBy: true,
          Cell: SocietyUserActionsCell,
        },
      ]);
      setSURows(res.data.map((row, index) => ({ sno: index + 1, ...row })));
      setSUView(true);
    } catch (error) {
      console.error("Error fetching society users:", error);
      showSnackbar("Failed to fetch society users", "error");
    }
  };
  const openCollegeUserDialog = (college_id, college_name, society_id) => {
    setCollegeUserFormData({
      society_id,
      college_id,
      college_name,
      db_instance_id: user.db_instance_id,
      user_email: "",
      user_name: "",
      user_role_id: "2",
      is_user_active: "1",
      user_password: "",
    });
    setCUOpen(true);
    setCUEditingId(null);
    setCollegeId(college_id);
    setCollegeName(college_name);
    setSocietyId(society_id);
    setCollegeUserFormErrors({});
  };
  const openCollegeUsersView = async (college_id, college_name, society_id) => {
    setCollegeId(college_id);
    setCollegeName(college_name);
    setSocietyId(society_id);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/auth/users-by-college/${college_id}`, {
        headers: getAuthHeaders(),
      });
      setCUColumns([
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
          accessor: "sno",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>User Name</span>,
          accessor: "user_name",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>User Email</span>,
          accessor: "user_email",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Active</span>,
          accessor: "is_user_active",
          Cell: UserStatusCell,
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
          accessor: "actions",
          align: "center",
          disableSortBy: true,
          Cell: CollegeUserActionsCell,
        },
      ]);
      setCURows(res.data.map((row, index) => ({ sno: index + 1, ...row })));
      setCUView(true);
    } catch (error) {
      console.error("Error fetching college users:", error);
      showSnackbar("Failed to fetch college users", "error");
    }
  };
  const openCollegeProgramDialog = (college_id, college_name, db_instance_id) => {
    setCollegeProgramFormData({
      college_id,
      college_name,
      db_instance_id,
      program_name: "",
      program_desc: "",
      program_duration: "",
      program_start_year: "",
      is_program_active: "",
    });
    setCPOpen(true);
    setCPEditingId(null);
    setCollegeId(college_id);
    setCollegeName(college_name);
    setCollegeProgramFormErrors({});
  };
  const openAdmissionBatchDialog = (college_id, college_name, db_instance_id) => {
    setAdmissionBatchFormData({
      college_id,
      db_instance_id,
      is__active: "",
      admissionbatch_year: "",
    });
    setABOpen(true);
    setABEditingId(null);
    setCollegeId(college_id);
    setCollegeName(college_name);
    setAdmissionBatchFormErrors({});
  };
  const openProgramBranchDialog = (program_id, college_id, program_name, db_instance_id) => {
    setProgramBranchFormData({
      program_id,
      college_id,
      program_name,
      db_instance_id,
      branch_name: "",
      branch_desc: "",
      branch_start_year: "",
      is_branch_active: "",
    });
    setPBOpen(true);
    setPBEditingId(null);
    setProgramId(program_id);
    setCollegeId(college_id);
    setProgramName(program_name);
    setProgramBranchFormErrors({});
  };
  const openCollegesView = async (society_id, society_name) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/colleges/${user.client_id}/${society_id}`, {
        headers: getAuthHeaders(),
      });

      setCColumns([
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
          accessor: "sno",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>College Name</span>,
          accessor: "college_name",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>College Code</span>,
          accessor: "college_code",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Active</span>,
          accessor: "is_college_active",
          Cell: CollegeStatusCell,
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
          accessor: "actions",
          align: "center",
          disableSortBy: true,
        },
      ]);

      const formattedRows = res.data.map((row, index) => ({
        sno: index + 1,
        ...row,
        society_id: Number(row.society_id || society_id),
        actions: (
          <RowCollegeActionsMenu
            row={{ ...row, society_id: Number(row.society_id || society_id) }}
            onEdit={handleCollegeEdit}
            onDelete={handleCollegeDelete}
            onUploadLogo={openCollegeLogoDialog}
            onCreateCollegeUser={openCollegeUserDialog}
            onCreateCollegeProgram={openCollegeProgramDialog}
            onCreateAdmissionBatch={openAdmissionBatchDialog}
            onViewCollegeUsers={openCollegeUsersView}
            onViewCollegePrograms={openCollegeProgramsView}
            hasPermissionDirect={hasPermissionDirect}
          />
        ),
      }));
      setCRows(formattedRows);
      setOpenCollegesView(true);
      setCOpen(false);
      setSocietyId(society_id);
      setSocietyName(society_name);
    } catch (error) {
      console.error("Error fetching colleges:", error);
      showSnackbar("Failed to fetch colleges", "error");
    }
  };
  const openCollegeProgramsView = async (college_id, college_name, program_id, program_name) => {
    await fetchTableData({
      url: `${API_BASE_URL}/api/programs/${user.client_id}/${college_id}`,
      onEdit: handleCollegeProgramEdit,
      onDelete: handleCollegeProgramDelete,
      onExtraAction: {
        onCreateProgramBranch: openProgramBranchDialog,
        onViewProgramBranches: openProgramBranchesView,
        db_instance_id: user.db_instance_id,
        hasPermissionDirect,
      },
      setColumns: setCPColumns,
      setRows: setCPRows,
      customActionComponent: (props) => (
        <RowProgramActionsMenu
          {...props}
          onCreateProgramBranch={props.onExtraAction?.onCreateProgramBranch}
          onViewProgramBranches={props.onExtraAction?.onViewProgramBranches}
          db_instance_id={props.onExtraAction?.db_instance_id}
          hasPermissionDirect={props.onExtraAction?.hasPermissionDirect}
        />
      ),
    });
    setCPView(true);
    setCPOpen(false);
    setCollegeId(college_id);
    setCollegeName(college_name);
  };
  const openProgramBranchesView = async (program_id, college_id, program_name) => {
    await fetchTableData({
      url: `${API_BASE_URL}/api/branches/${user.client_id}/${college_id}?programId=${program_id}`,
      onEdit: handleProgramBranchEdit,
      onDelete: handleProgramBranchDelete,
      onExtraAction: {
        onCreateProgramBranch: openProgramBranchDialog,
        onViewProgramBranches: openProgramBranchesView,
        db_instance_id: user.db_instance_id,
        hasPermissionDirect,
      },
      setColumns: setPBColumns,
      setRows: setPBRows,
      customActionComponent: (props) => (
        <RowBranchActionsMenu
          {...props}
          onCreateBranchIntake={openBranchIntakeDialog}
          onViewBranchIntakes={openBranchIntakesView}
          hasPermissionDirect={props.onExtraAction?.hasPermissionDirect}
        />
      ),
    });
    setPBView(true);
    setPBOpen(false);
    setProgramId(program_id);
    setProgramName(program_name);
  };
  const openBranchIntakeDialog = async (branch_id, program_id, college_id, branch_name) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/admittedbatches/${user.client_id}/${college_id}`,
        { headers: getAuthHeaders() }
      );
      setAdmissionBatchOptions(
        (res.data?.items || []).map((batch) => ({
          value: String(batch.admittedbatch_id),
          label: batch.admittedbatch,
        }))
      );
      setBranchId(branch_id);
      setProgramId(program_id);
      setCollegeId(college_id);
      setBranchName(branch_name);
      setBranchIntakeFormData({ admittedbatch_id: "", intake: "" });
      setBranchIntakeFormErrors({});
      setBIOpen(true);
    } catch (error) {
      showSnackbar(error.response?.data?.message || "Failed to load admission batches", "error");
    }
  };
  const openBranchIntakesView = async (branch_id, program_id, college_id, branch_name) => {
    await fetchTableData({
      url: `${API_BASE_URL}/api/map_admittedbatch_branch/${user.client_id}/${college_id}?branchId=${branch_id}&flat=1`,
      setColumns: setBIColumns,
      setRows: setBIRows,
    });
    setBranchId(branch_id);
    setProgramId(program_id);
    setCollegeId(college_id);
    setBranchName(branch_name);
    setBIView(true);
  };
  const openCollegeLogoDialog = (college_id, college_name, society_id, college_logopath) => {
    setCollegeId(college_id);
    setCollegeName(college_name);
    setLogoDialogOpen(true);
    setExistsUrl(college_logopath);
  };
  const openCollegeDialog = (society_id, society_name, db_instance_id) => {
    setCollegeFormData({
      society_id,
      society_name,
      db_instance_id,
      college_name: "",
      is_college_active: "",
      college_code: "",
      college_refurl: "",
      college_email: "",
      college_validity: "",
      college_logopath: "",
    });
    setCOpen(true);
    setCEditingId(null);
    setSocietyId(society_id);
    setSocietyName(society_name);
    setCollegeFormErrors({});
  };
  const handleCollegeEdit = (row) => {
    setCollegeFormData({ ...row });
    setCEditingId(row.college_id);
    setCollegeId(row.college_id);
    setCollegeName(row.college_name);
    setCOpen(true);
  };
  const handleCollegeStatusToggle = async (row) => {
    const currentUser = JSON.parse(sessionStorage.getItem("user"));
    const currentSocietyId = row.society_id || societyId;
    const nextStatus = nextActiveValue(row.is_college_active);

    try {
      await axios.put(
        `${API_BASE_URL}/api/colleges/${currentUser.client_id}/${currentSocietyId}/${row.college_id}`,
        buildCollegePayload(row, currentUser, nextStatus),
        {
          headers: getAuthHeaders(),
        }
      );
      showSnackbar(
        `College status updated to ${nextStatus === 1 ? "Active" : "Inactive"}`,
        "success"
      );
      openCollegesView(currentSocietyId, societyName || row.society_name);
    } catch (error) {
      console.error("Error updating college status:", error);
      showSnackbar("Error updating college status", "error");
    }
  };
  const handleCollegeProgramEdit = (row) => {
    setCollegeProgramFormData({ ...row });
    setCPEditingId(row.program_id);
    setProgramId(row.program_id);
    setProgramName(row.program_name);
    setCPOpen(true);
  };
  const handleProgramBranchEdit = (row) => {
    setProgramBranchFormData({ ...row });
    setPBEditingId(row.branch_id);
    setBranchId(row.branch_id);
    setBranchName(row.branch_name);
    setPBOpen(true);
  };
  const handleAdmissionBatchEdit = (row) => {
    setAdmissionBatchFormData({ ...row });
    setABEditingId(row.admissionbatch_id);
    setAdmissionBatchId(row.admissionbatch_id);
    setAdmissionBatchName(row.admissionbatch_year);
    setABOpen(true);
  };
  const handleCollegeProgramDelete = async (program_id) => {
    const confirm2 = await Swal.fire({
      title: "Sure to delete Program?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm2.isConfirmed) {
      let response;
      try {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-program.php?action=delete&program_id=${program_id}&db_instance_id=${user.db_instance_id}`,
          null,
          {
            headers: getAuthHeaders(),
          }
        );
        if (response.status === 200) {
          showSnackbar(" Program Deleted successfully", "success");
        } else {
          showSnackbar(" Program is not Deleted ", "error");
        }
        openCollegeProgramsView(collegeId, collegeName);
      } catch (err) {
        showSnackbar("Error deleting program", "error");
      }
    }
  };
  const handleProgramBranchDelete = async (branch_id) => {
    const confirm2 = await Swal.fire({
      title: "Sure to delete Branch?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm2.isConfirmed) {
      let response;
      try {
        response = await axios.delete(
          `${API_BASE_URL}/api/branches/${user.client_id}/${branch_id}`,
          {
            headers: getAuthHeaders(),
          }
        );
        if (response.status === 200) {
          showSnackbar(" Branch Deleted successfully", "success");
        } else {
          showSnackbar(" Branch is not Deleted ", "error");
        }
        openProgramBranchesView(programId, collegeId, programName);
      } catch (err) {
        showSnackbar("Error deleting program", "error");
      }
    }
  };
  const handleCollegeUploadLogo = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("client_id", user.client_id);
    formData.append("college_id", collegeId);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/bootstrap-college.php?action=upload&college_id=${collegeId}&db_instance_id=${user.db_instance_id}&client_id=${user.client_id}`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success) {
        showSnackbar("Logo uploaded successfully.", "success");
      } else {
        showSnackbar(response.data.message || "Failed to upload logo", "error");
      }
    } catch (error) {
      console.error("Upload error:", error);
      showSnackbar("Error uploading logo", "error");
    }
  };

  const handleCollegeSave = async () => {
    const errors = {};

    if (!collegeFormData.college_name?.trim()) {
      errors.college_name = "College name is required";
    }

    if (!collegeFormData.college_code?.trim()) {
      errors.college_code = "College code is required";
    }

    if (collegeFormData.is_college_active === "") {
      errors.is_college_active = "Select active status";
    }
    if (!collegeFormData.college_refurl?.trim()) {
      errors.college_refurl = " Referal url is required";
    }
    if (!collegeFormData.college_email?.trim()) {
      errors.college_email = " Email is required to send GUID-Token";
    }

    setCollegeFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const currentSocietyId = collegeFormData.society_id || societyId;
      const payload = buildCollegePayload(collegeFormData, user);
      let response;
      if (ceditingId) {
        response = await axios.put(
          `${API_BASE_URL}/api/colleges/${user.client_id}/${currentSocietyId}/${ceditingId}`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/api/colleges`,
          {
            ...payload,
            created_by: userName,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        openCollegesView(currentSocietyId, societyName);
        showSnackbar(message, "success");
        setCOpen(false);
      } else {
        showSnackbar("Failed to create college", "error");
      }
    } catch (error) {
      console.error("Error creating college:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleCollegeProgramSave = async () => {
    const errors = {};

    if (!collegeProgramFormData.program_name?.trim()) {
      errors.program_name = "Program name is required";
    }

    if (!collegeProgramFormData.program_desc?.trim()) {
      errors.program_desc = "Program description is required";
    }

    if (collegeProgramFormData.is_program_active === "") {
      errors.is_program_active = "Select active status";
    }
    if (collegeProgramFormData.program_duration === "") {
      errors.program_duration = "Program duration is required";
    }
    if (collegeProgramFormData.program_start_year === "") {
      errors.program_start_year = "Program start year is required";
    }

    setCollegeProgramFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        ...collegeProgramFormData,
        created_by: userName,
        updated_by: userName,
        client_id: user.client_id,
        college_id: collegeId,
        db_instance_id: user.db_instance_id,
      };
      let response;
      if (cpeditingId) {
        response = await axios.put(
          `${API_BASE_URL}/api/programs/${user.client_id}/${cpeditingId}`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(`${API_BASE_URL}/api/programs`, payload, {
          headers: getAuthHeaders(),
        });
      }
      if (response.status >= 200 && response.status < 300 && response.data?.success !== false) {
        const { message } = response.data;
        openCollegeProgramsView(collegeId, collegeName);
        showSnackbar(message || "Program saved successfully", "success");
        setCPOpen(false);
      } else {
        showSnackbar(response.data?.message || "Failed to save program", "error");
      }
    } catch (error) {
      console.error("Error saving program:", error);
      showSnackbar(error.response?.data?.message || "Error occurred during save", "error");
    }
  };
  const handleSocietyUserDelete = async (user_id) => {
    const confirm2 = await Swal.fire({
      title: "Sure to delete Society User?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm2.isConfirmed) {
      try {
        await axios.delete(`${API_BASE_URL}/api/auth/users/${user_id}`, {
          headers: getAuthHeaders(),
        });
        showSnackbar("Society user deleted successfully", "success");
        openSocietyUsersView(societyId, societyName);
      } catch (err) {
        console.error("Error deleting society user:", err);
        showSnackbar("Error deleting society user", "error");
      }
    }
  };
  const handleCollegeUserDelete = async (user_id) => {
    const confirm2 = await Swal.fire({
      title: "Sure to delete College User?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm2.isConfirmed) {
      try {
        await axios.delete(`${API_BASE_URL}/api/auth/users/${user_id}`, {
          headers: getAuthHeaders(),
        });
        showSnackbar("College user deleted successfully", "success");
        openCollegeUsersView(collegeId, collegeName, societyId);
      } catch (err) {
        console.error("Error deleting college user:", err);
        showSnackbar("Error deleting college user", "error");
      }
    }
  };
  const handleSocietyUserSave = async () => {
    const errors = {};

    if (!societyUserFormData.user_name?.trim()) {
      errors.user_email = "User name is required";
    }

    if (!societyUserFormData.user_email?.trim()) {
      errors.user_email = "User Email is required";
    }

    setSocietyUserFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        ...societyUserFormData,
        created_by: userName,
        client_id: user.client_id,
        society_id: societyId,
        college_id: null,
        user_role_id: Number(societyUserFormData.user_role_id || 2),
        is_user_active: Number(societyUserFormData.is_user_active ?? 1),
        user_password: societyUserFormData.user_password || societyUserFormData.user_email,
      };
      let response;
      if (sueditingId) {
        response = await axios.put(`${API_BASE_URL}/api/auth/users/${sueditingId}`, payload, {
          headers: getAuthHeaders(),
        });
      } else {
        response = await axios.post(`${API_BASE_URL}/api/auth/add-user`, payload, {
          headers: getAuthHeaders(),
        });
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        openSocietyUsersView(societyId, societyName);
        showSnackbar(message, "success");
        setSUOpen(false);
      } else {
        showSnackbar("Failed to create Society user", "error");
      }
    } catch (error) {
      console.error("Error creating user:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleCollegeUserSave = async () => {
    const errors = {};

    if (!collegeUserFormData.user_name?.trim()) {
      errors.user_name = "User name is required";
    }

    if (!collegeUserFormData.user_email?.trim()) {
      errors.user_email = "User Email is required";
    }

    setCollegeUserFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        ...collegeUserFormData,
        created_by: userName,
        client_id: user.client_id,
        college_id: collegeId,
        user_role_id: Number(collegeUserFormData.user_role_id || 2),
        is_user_active: Number(collegeUserFormData.is_user_active ?? 1),
        user_password: collegeUserFormData.user_password || collegeUserFormData.user_email,
      };
      let response;
      if (cueditingId) {
        response = await axios.put(`${API_BASE_URL}/api/auth/users/${cueditingId}`, payload, {
          headers: getAuthHeaders(),
        });
      } else {
        response = await axios.post(`${API_BASE_URL}/api/auth/add-user`, payload, {
          headers: getAuthHeaders(),
        });
      }
      if (response.status === 200) {
        const { message } = response.data;
        openCollegeUsersView(collegeId, collegeName, societyId);
        showSnackbar(message, "success");
        setCUOpen(false);
      } else {
        showSnackbar("Failed to create college user", "error");
      }
    } catch (error) {
      console.error("Error creating college user:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleProgramBranchSave = async () => {
    const errors = {};

    if (!programBranchFormData.branch_name?.trim()) {
      errors.branch_name = "Branch name is required";
    }

    if (!programBranchFormData.branch_desc?.trim()) {
      errors.branch_desc = "Branch Description is required";
    }
    if (programBranchFormData.branch_start_year === "") {
      errors.branch_start_year = "Branch Started Year is required";
    }

    if (programBranchFormData.is_branch_active === "") {
      errors.is_branch_active = "Set Branch Active";
    }

    setProgramBranchFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        ...programBranchFormData,
        created_by: user.user_email,
        updated_by: userName,
        client_id: user.client_id,
        college_id: collegeId,
        program_id: programId,
        db_instance_id: user.db_instance_id,
      };
      let response;
      if (pbeditingId) {
        response = await axios.put(
          `${API_BASE_URL}/api/branches/${user.client_id}/${pbeditingId}`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(`${API_BASE_URL}/api/branches`, payload, {
          headers: getAuthHeaders(),
        });
      }
      if (response.status >= 200 && response.status < 300 && response.data?.success !== false) {
        const { message } = response.data;
        openProgramBranchesView(programId, collegeId, programName, user.db_instance_id);
        showSnackbar(message || "Branch saved successfully", "success");
        setPBOpen(false);
      } else {
        showSnackbar("Failed to create  branch", "error");
      }
    } catch (error) {
      console.error("Error saving branch:", error);
      showSnackbar(error.response?.data?.message || "Error occurred during save", "error");
    }
  };
  const handleAdmissionBatchSave = async () => {
    const errors = {};

    if (!admissionBatchFormData.admissionbatch_year?.trim()) {
      errors.admissionbatch_year = "Admission batch year is required";
    }
    if (admissionBatchFormData.is_active === "") {
      errors.is_active = "Set Admission Year Active";
    }

    setAdmissionBatchFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        client_id: user.client_id,
        college_id: collegeId,
        admittedbatch: String(admissionBatchFormData.admissionbatch_year),
        status: Number(admissionBatchFormData.is_active) === 1 ? "ACTIVE" : "INACTIVE",
        created_by: userName,
      };
      let response;
      if (abeditingId) {
        response = await axios.put(
          `${API_BASE_URL}/api/admittedbatches/${user.client_id}/${collegeId}/${abeditingId}`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/api/admittedbatches/${user.client_id}/${collegeId}`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status >= 200 && response.status < 300 && response.data?.success !== false) {
        showSnackbar(response.data?.message || "Admission batch saved successfully", "success");
        setABOpen(false);
      } else {
        showSnackbar("Failed to create  admitted batch", "error");
      }
    } catch (error) {
      console.error("Error saving admission batch:", error);
      showSnackbar(error.response?.data?.message || "Error occurred during save", "error");
    }
  };
  const handleBranchIntakeSave = async () => {
    const errors = {};
    if (!branchIntakeFormData.admittedbatch_id) {
      errors.admittedbatch_id = "Admission batch is required";
    }
    if (branchIntakeFormData.intake === "" || Number(branchIntakeFormData.intake) < 0) {
      errors.intake = "Valid intake is required";
    }
    setBranchIntakeFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    try {
      const currentUser = JSON.parse(sessionStorage.getItem("user"));
      const response = await axios.post(
        `${API_BASE_URL}/api/map_admittedbatch_branch`,
        {
          client_id: currentUser.client_id,
          college_id: collegeId,
          program_id: programId,
          branch_id: branchId,
          admittedbatch_id: Number(branchIntakeFormData.admittedbatch_id),
          intake: Number(branchIntakeFormData.intake),
          created_by: currentUser.user_email || "unknown",
        },
        { headers: getAuthHeaders() }
      );
      showSnackbar(response.data?.message || "Branch intake saved successfully", "success");
      setBIOpen(false);
    } catch (error) {
      showSnackbar(error.response?.data?.message || "Error occurred during save", "error");
    }
  };
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const societyfields = [
    {
      name: "society_name",
      label: "Society Name",
      type: "text",
    },
    {
      name: "society_code",
      label: "Society Code",
      type: "text",
    },
    {
      name: "society_email",
      label: "Society Email",
      type: "email",
    },
    {
      name: "is_society_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
  ].filter(Boolean);

  const societyuserfields = [
    {
      name: "user_name",
      label: "User Name",
      type: "text",
    },
    {
      name: "user_email",
      label: "User Email",
      type: "email",
    },
    {
      name: "user_role_id",
      label: "User Role",
      type: "select",
      options: [
        { value: "2", label: "Client Admin" },
        { value: "1", label: "System Admin" },
      ],
    },
    {
      name: "is_user_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
    {
      name: "user_password",
      label: "Password",
      type: "password",
    },
  ].filter(Boolean);
  const collegefields = [
    {
      name: "college_name",
      label: "College Name",
      type: "text",
    },
    {
      name: "college_code",
      label: "College Code",
      type: "text",
    },
    {
      name: "college_email",
      label: "College Email",
      type: "email",
    },
    {
      name: "college_refurl",
      label: "College Referral URL",
      type: "text",
    },
    {
      name: "college_validity",
      label: "Validity (Months)",
      type: "select",
      options: [
        { value: "3", label: "3 Months" },
        { value: "6", label: "6 Months" },
        { value: "12", label: "12 Months" },
        { value: "24", label: "24 Months" },
      ],
    },
    {
      name: "is_college_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
  ].filter(Boolean);
  const collegeprogramfields = [
    {
      name: "program_name",
      label: "Program Name",
      type: "text",
    },
    {
      name: "program_desc",
      label: "Program Description",
      type: "text",
    },
    {
      name: "program_duration",
      label: "Program Duration",
      type: "number",
    },
    {
      name: "program_start_year",
      label: "Program StartYear",
      type: "number",
    },
    {
      name: "is_program_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
  ].filter(Boolean);
  const programbranchfields = [
    {
      name: "branch_name",
      label: "Branch Name",
      type: "text",
    },
    {
      name: "branch_desc",
      label: "Branch Description",
      type: "text",
    },
    {
      name: "branch_start_year",
      label: "Branch StartYear",
      type: "number",
    },
    {
      name: "is_branch_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
  ].filter(Boolean);
  const admissionbatchfields = [
    {
      name: "admissionbatch_year",
      label: "Admission Batch Year",
      type: "number",
    },
    {
      name: "is_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
  ].filter(Boolean);
  const branchintakefields = [
    {
      name: "admittedbatch_id",
      label: "Admission Batch",
      type: "select",
      options: admissionBatchOptions,
    },
    { name: "intake", label: "Branch Intake", type: "number" },
  ];
  const handleSocietyChange = (name, value) => {
    setSocietyFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSocietyUserChange = (name, value) => {
    setSocietyUserFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleCollegeUserChange = (name, value) => {
    setCollegeUserFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleCollegeChange = (name, value) => {
    setCollegeFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleCollegeProgramChange = (name, value) => {
    setCollegeProgramFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleProgramBranchChange = (name, value) => {
    setProgramBranchFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleAdmissionBatchChange = (name, value) => {
    setAdmissionBatchFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleBranchIntakeChange = (name, value) => {
    setBranchIntakeFormData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <DashboardLayoutMin>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    SOCIETIES MANAGEMENT
                  </MDTypography>
                  {hasPermissionDirect("create") && (
                    <MDButton
                      variant="contained"
                      color="white"
                      onClick={openSocietyDialog}
                      sx={{ ml: 2 }}
                    >
                      Add Society
                    </MDButton>
                  )}
                </MDBox>
              </MDBox>
              {scolumns.length > 0 && (
                <MDBox pt={2}>
                  <DataTable
                    table={{ columns: scolumns, rows: srows }}
                    isSorted={true}
                    entriesPerPage={true}
                    showTotalEntries={true}
                    canSearch={true}
                    noEndBorder
                  />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
        <MuiAlert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      <LogoDialog
        open={logoDialogOpen}
        onClose={() => setLogoDialogOpen(false)}
        onUpload={handleCollegeUploadLogo}
        existingLogoUrl={existUrl}
      />

      <DynamicDialog
        open={sopen}
        onClose={() => setSOpen(false)}
        title={seditingId ? "Edit Society " : "Add Society"}
        formData={societyFormData}
        formErrors={societyFormErrors}
        fields={societyfields}
        onChange={handleSocietyChange}
        onSave={handleSocietySave}
      />
      <DynamicDialog
        open={suopen}
        onClose={() => setSUOpen(false)}
        title={
          sueditingId
            ? "Edit Society user of " + `${societyName}`
            : "Add Society user for " + `${societyName}`
        }
        formData={societyUserFormData}
        formErrors={societyUserFormErrors}
        fields={societyuserfields}
        onChange={handleSocietyUserChange}
        onSave={handleSocietyUserSave}
      />
      <DynamicDialog
        open={cuopen}
        onClose={() => setCUOpen(false)}
        title={
          cueditingId
            ? "Edit College user of " + `${collegeName}`
            : "Add College user for " + `${collegeName}`
        }
        formData={collegeUserFormData}
        formErrors={collegeUserFormErrors}
        fields={societyuserfields}
        onChange={handleCollegeUserChange}
        onSave={handleCollegeUserSave}
      />
      <DynamicDialog
        open={copen}
        onClose={() => setCOpen(false)}
        title={
          ceditingId ? "Edit College of " + `${societyName}` : "Add College for " + `${societyName}`
        }
        formData={collegeFormData}
        formErrors={collegeFormErrors}
        fields={collegefields}
        onChange={handleCollegeChange}
        onSave={handleCollegeSave}
      />
      <DynamicDialog
        open={abopen}
        onClose={() => setABOpen(false)}
        title={
          abeditingId
            ? "Edit Admission Batch of " + `${collegeName}`
            : "Add Admission Batch for " + `${collegeName}`
        }
        formData={admissionBatchFormData}
        formErrors={admissionBatchFormErrors}
        fields={admissionbatchfields}
        onChange={handleAdmissionBatchChange}
        onSave={handleAdmissionBatchSave}
      />
      <DynamicDialog
        open={cpopen}
        onClose={() => setCPOpen(false)}
        title={
          cpeditingId
            ? "Edit Program of " + `${collegeName}`
            : "Add Program for " + `${collegeName}`
        }
        formData={collegeProgramFormData}
        formErrors={collegeProgramFormErrors}
        fields={collegeprogramfields}
        onChange={handleCollegeProgramChange}
        onSave={handleCollegeProgramSave}
      />
      <DynamicDialog
        open={pbopen}
        onClose={() => setPBOpen(false)}
        title={
          pbeditingId ? "Edit Branch of " + `${programName}` : "Add Branch for " + `${programName}`
        }
        formData={programBranchFormData}
        formErrors={programBranchFormErrors}
        fields={programbranchfields}
        onChange={handleProgramBranchChange}
        onSave={handleProgramBranchSave}
      />
      <DynamicDialog
        open={biopen}
        onClose={() => setBIOpen(false)}
        title={`Add Branch Intake for ${branchName || "branch"}`}
        formData={branchIntakeFormData}
        formErrors={branchIntakeFormErrors}
        fields={branchintakefields}
        onChange={handleBranchIntakeChange}
        onSave={handleBranchIntakeSave}
      />
      <Dialog open={biview} onClose={() => setBIView(false)} fullWidth maxWidth="md">
        <DialogTitle>
          Branch Intakes: {branchName}
          <IconButton onClick={() => setBIView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DataTable
            table={{ columns: bicolumns, rows: birows }}
            isSorted={true}
            entriesPerPage={true}
            showTotalEntries={true}
            canSearch={true}
            noEndBorder
          />
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={() => setBIView(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={suview}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setSUView(false);
          }
        }}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          Users List of Society: {societyName}
          <IconButton onClick={() => setSUView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(233, 24.30%, 92.70%),rgb(206, 213, 225))",
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: sucolumns, rows: surows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setSUView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openCollegesData}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setOpenCollegesView(false);
          }
        }}
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "60%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          Colleges List of Society: {societyName}
          <IconButton onClick={() => setOpenCollegesView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(233, 24.30%, 92.70%),rgb(206, 213, 225))",
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: ccolumns, rows: crows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setOpenCollegesView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={cuview}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setCUView(false);
          }
        }}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          Users List of College: {collegeName}
          <IconButton onClick={() => setCUView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(233, 24.30%, 92.70%),rgb(206, 213, 225))",
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: cucolumns, rows: curows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setCUView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={cpview}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setCPView(false);
          }
        }}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          Programs List of college: {collegeName}
          <IconButton onClick={() => setCPView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(233, 24.30%, 92.70%),rgb(206, 213, 225))",
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: cpcolumns, rows: cprows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setCPView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={pbview}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setPBView(false);
          }
        }}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          Branches List of Program: {programName}
          <IconButton onClick={() => setPBView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(233, 24.30%, 92.70%),rgb(206, 213, 225))",
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: pbcolumns, rows: pbrows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setPBView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayoutMin>
  );
}
SocietyClient.propTypes = {
  onExtraAction: PropTypes.shape({
    onUploadLogo: PropTypes.func,
    onCreateSocietyUser: PropTypes.func,
    onCreateCollegeUser: PropTypes.func,
    onCreateCollegeProgram: PropTypes.func,
    onViewSocietyUsers: PropTypes.func,
    onViewColleges: PropTypes.func,
    onViewCollegeUsers: PropTypes.func,
    onViewCollegePrograms: PropTypes.func,
    onCreateProgramBranch: PropTypes.func,
    onViewProgramBranches: PropTypes.func,
    onCreateAdmissionBatch: PropTypes.func,
    db_instance_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hasPermissionDirect: PropTypes.func,
  }),
};
export default SocietyClient;
